export default __webpack_public_path__ + "static/media/donate-qr.0daa64fe.jpeg";